// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';            // Archivo de estilos globales
import App from './App';         // Componente principal de la aplicación
import reportWebVitals from './reportWebVitals';  // Para medir el rendimiento (opcional)

// Importa HelmetProvider de 'react-helmet-async'
import { HelmetProvider } from 'react-helmet-async';

// Se obtiene el contenedor 'root' en el HTML
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* Envolvemos la App con HelmetProvider para que 'react-helmet-async' funcione */}
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Si deseas medir el rendimiento de tu aplicación, descomenta o personaliza reportWebVitals.
reportWebVitals();
